.in-trial-text {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  margin-bottom: var(--spacer);

  gz-form-field {
    --margin-bottom-wrapper: 0;
  }
}

#own-use-xdr-sensors-details {
  font-size: var(--body-size-large);
  line-height: 18px;
}

.trial-started-text {
  height: 24px;
  width: 88px;
  background-color: var(--chart-050-hover);
  border-radius: 16px;
  box-sizing: border-box;
  font-family: 'Montserrat-Regular', 'Montserrat', sans-serif;
  color: var(--body-text-arrows-400);
  text-align: center;
  line-height: 18px;
  font-size: 12px;
  padding-top: 4px;
}

gz-form-field {
  --margin-bottom-wrapper: var(--spacer);
}

gz-toggle {
  --margin-vertical: 6px;
}

gz-radio {
  height: calc(4 * var(--spacer));
  display: flex;
}
